'use strict';

import { getCart, addToCart, updateCart } from './cart-api.js';

document.addEventListener("DOMContentLoaded", function () {
    const giftSettings = JSON.parse(window.giftSettings);
    
    if (giftSettings !== undefined && giftSettings.length > 0) {

      const checkCartForGifts = () => {
        getCart()
        .then((cart) => {
          giftSettings.forEach((gwpInfo) => {
            const isTargetProductInCart = cart.items.some(
              (item) => item.product_id === parseInt(gwpInfo.targetProductId)
            );

            const isGiftInCart = cart.items.some(
              (item) => item.variant_id === parseInt(gwpInfo.giftProductId)
            );

            // Check if target product is not in the cart and remove the gift
            if (!isTargetProductInCart) {
              const giftItem = cart.items.find(
                (item) => item.variant_id === parseInt(gwpInfo.giftProductId)
              );
      
              if (giftItem) {
                removeItemFromCart(giftItem.key);
              }
            }

            // Add the gift to the cart
            if (isTargetProductInCart && !isGiftInCart) {
              addGift(parseInt(gwpInfo.giftProductId));
            }
          });
        })
        .catch((error) => {
          console.error('Error getting the cart:', error);
        });
      };
  
      const addGift = (giftProductId) => {
        const props = {
          id: giftProductId,
          quantity: 1,
          sections: getSectionsToReload().map((section) => section.id),
          sections_url: window.location.pathname
        };

        addToCart(props)
        .then((response) => {
          // Fire a cartUpdate event
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'gift-with-purchase'});
          reloadSections(response);
        })
        .catch((error) => {
          console.error('Error adding gift to the cart:', error);
        });
      };

      const removeItemFromCart = (productKey) => {
        const props = {
          id: productKey,
          quantity: 0,
          sections: getSectionsToReload().map((section) => section.id),
          sections_url: window.location.pathname
        };

        updateCart(props)
        .then((response) => {
          // Fire a cartUpdate event
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'gift-with-purchase'});
          reloadSections(response);
        })
        .catch((error) => {
          console.error('Error removing gift:', error);
        });
      };

      // Function to reload the sections without reload the entire page
      const reloadSections = (parsedState) => {
        getSectionsToReload().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (sectionElement) {
            sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          }
        });

        const cartDrawerOverlay = this.querySelector('#CartDrawer-Overlay');
        if (cartDrawerOverlay) {
          cartDrawerOverlay.addEventListener('click', close, { once: true });
        }
        open();
      };

      // Function to open the cart drawer modal (we need to attach it every time we update the cart)
      const open = (triggeredBy) => {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
          this.setSummaryAccessibility(cartDrawerNote);
        }

        const cartDrawerOverlay = this.querySelector('#CartDrawer-Overlay');
        if (cartDrawerOverlay) {
          cartDrawerOverlay.classList.add('animate', 'active');
          const subCartDrawer = this.querySelector('subcart-drawer');
          if (subCartDrawer) setTimeout(() => {this.querySelector('subcart-drawer').openSubDrawer()});
        }

        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems && cartDrawerItems.classList.contains('is-empty')) {
          const cartDrawer = this.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.classList.add('is-empty');
        }
        document.body.classList.add('overflow-hidden');
      }
      
      // Function to close the cart drawer modal (we need to attach it every time we update the cart)
      const close = () => {
        if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').closeSubDrawer();
        this.querySelector('#CartDrawer-Overlay').classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }

      const getSectionInnerHTML = (html, selector = '.shopify-section') => {
        return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
      };

      // List of sections to be updated when we add a new product to the cart
      const getSectionsToReload = () => {
        return [
          {
            id: 'cart-drawer',
            selector: '#CartDrawer',
          },
          {
            id: 'cart-icon-bubble'
          }
        ];
      };

      // Listen for cart changes different from gift-with-purchase
      if (window.publish !== undefined && window.subscribe !== undefined && PUB_SUB_EVENTS?.cartUpdate !== undefined) {
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
          if (e.source === 'gift-with-purchase' || e.source === 'check-cart-logout') {
            return;
          }
          checkCartForGifts();
        });
      }
    }
});